import VehicleType from '@/enums/VehicleType';

export default class ValuationVehicle {
  public name: string = '';

  public plateYear: string | null = null;

  public vehicleType: VehicleType = VehicleType.Car;
}
